import {Link} from "react-router-dom";

export function ChangesetLink(props: {
    projectId: number;
    changeset: {
        id: number;
        projSeqNumber: number;
        name: string;
    };
}) {
    return (
        <Link to={`/project/${props.projectId}/shop-drawing/changeset/${props.changeset.id}/preview`}>
            Changeset #{props.changeset.projSeqNumber}{props.changeset.name ? ": " + props.changeset.name : ""}
        </Link>
    )
}
